// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 600px) {

    .button {
        display: inline-block;
        padding: 0.5em 1em;
        border: 1px solid #ccc;
        border-radius: 7px;
        width: 87%;
        background: rgb(25, 32, 41);
        color: white;
        text-decoration: none;
        font-size: 1em;
        font-weight: 400;
        line-height: 1.5;
        text-align: center;
        cursor: pointer;
    }

    /* effect when mouse hover */
    .button:hover {
        background: rgb(25, 32, 41);
        color: white;
        border: 1px solid rgb(25, 32, 41);
    }

    /* effect when mouse click */
    .button:active {
        background: rgb(17, 20, 24);
        color: white;
        border: 1px solid rgb(25, 32, 41);
    }
}

@media only screen and (min-width: 600px) {

    .button {
        display: inline-block;
        padding: 0.5em 1em;
        border: 1px solid #ccc;
        border-radius: 7px;
        width: 53.5%;
        background: var(--ColorSecondary);
        color: white;
        text-decoration: none;
        font-size: 1em;
        font-weight: 400;
        line-height: 1.5;
        text-align: center;
        cursor: pointer;
    }

    /* effect when mouse hover */
    .button:hover {
        background: var(--ColorSecondary);
        color: white;
        border: 1px solid var(--ColorSecondary);
    }

    /* effect when mouse click */
    .button:active {
        background: var(--ColorLabelRed);
        color: white;
        border: 1px solid var(--ColorLabelRed);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/button/Button.css"],"names":[],"mappings":"AAAA;;IAEI;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,kBAAkB;QAClB,UAAU;QACV,2BAA2B;QAC3B,YAAY;QACZ,qBAAqB;QACrB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;;IAEA,4BAA4B;IAC5B;QACI,2BAA2B;QAC3B,YAAY;QACZ,iCAAiC;IACrC;;IAEA,4BAA4B;IAC5B;QACI,2BAA2B;QAC3B,YAAY;QACZ,iCAAiC;IACrC;AACJ;;AAEA;;IAEI;QACI,qBAAqB;QACrB,kBAAkB;QAClB,sBAAsB;QACtB,kBAAkB;QAClB,YAAY;QACZ,iCAAiC;QACjC,YAAY;QACZ,qBAAqB;QACrB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;;IAEA,4BAA4B;IAC5B;QACI,iCAAiC;QACjC,YAAY;QACZ,uCAAuC;IAC3C;;IAEA,4BAA4B;IAC5B;QACI,gCAAgC;QAChC,YAAY;QACZ,sCAAsC;IAC1C;AACJ","sourcesContent":["@media only screen and (max-width: 600px) {\n\n    .button {\n        display: inline-block;\n        padding: 0.5em 1em;\n        border: 1px solid #ccc;\n        border-radius: 7px;\n        width: 87%;\n        background: rgb(25, 32, 41);\n        color: white;\n        text-decoration: none;\n        font-size: 1em;\n        font-weight: 400;\n        line-height: 1.5;\n        text-align: center;\n        cursor: pointer;\n    }\n\n    /* effect when mouse hover */\n    .button:hover {\n        background: rgb(25, 32, 41);\n        color: white;\n        border: 1px solid rgb(25, 32, 41);\n    }\n\n    /* effect when mouse click */\n    .button:active {\n        background: rgb(17, 20, 24);\n        color: white;\n        border: 1px solid rgb(25, 32, 41);\n    }\n}\n\n@media only screen and (min-width: 600px) {\n\n    .button {\n        display: inline-block;\n        padding: 0.5em 1em;\n        border: 1px solid #ccc;\n        border-radius: 7px;\n        width: 53.5%;\n        background: var(--ColorSecondary);\n        color: white;\n        text-decoration: none;\n        font-size: 1em;\n        font-weight: 400;\n        line-height: 1.5;\n        text-align: center;\n        cursor: pointer;\n    }\n\n    /* effect when mouse hover */\n    .button:hover {\n        background: var(--ColorSecondary);\n        color: white;\n        border: 1px solid var(--ColorSecondary);\n    }\n\n    /* effect when mouse click */\n    .button:active {\n        background: var(--ColorLabelRed);\n        color: white;\n        border: 1px solid var(--ColorLabelRed);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
